export let Industry;

(function (Industry) {
  Industry["RealEstate"] = "real-estate";
})(Industry || (Industry = {}));